/*
  LadyCloshop — tarjetas de producto: al tocar un color, la foto de la tarjeta pasa a la de ese
  color (sin cambiar de página). Delegado en el documento: vale para colecciones, búsqueda y
  carruseles, también cuando se cargan más productos o se filtra.
*/
(function () {
  document.addEventListener('click', (event) => {
    const dot = event.target.closest('[data-lc-card-swatches] .lc-card-swatches__dot');
    if (!dot) return;
    event.preventDefault();
    event.stopPropagation();
    const card = dot.closest('.card-wrapper');
    dot.parentElement.querySelectorAll('.lc-card-swatches__dot').forEach((el) => el.classList.toggle('is-active', el === dot));
    const img = card?.querySelector('.card__media img');
    if (!img || !dot.dataset.src) return;
    img.srcset = dot.dataset.srcset;
    img.src = dot.dataset.src;
  });
})();
